import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AdminLayout, useAdminApi } from '@/components/AdminLayout';

export default function AdminWaitlistPage() {
  const api = useAdminApi();
  const [data, setData] = useState({ entries: [], total: 0 });

  const load = useCallback(() => {
    if (!api) return;
    api.get('/waitlist').then((r) => setData(r.data)).catch(() => toast.error('Failed to load waitlist'));
  }, [api]);

  useEffect(() => { load(); }, [load]);

  const remove = async (id) => {
    try {
      await api.delete(`/waitlist/${id}`);
      toast.success('Entry removed');
      load();
    } catch {
      toast.error('Delete failed');
    }
  };

  return (
    <AdminLayout>
      <div data-testid="admin-waitlist-page">
        <h1 className="text-2xl font-bold font-['Outfit']">Waitlist</h1>
        <p className="text-gray-400" data-testid="admin-waitlist-total">{data.total} sign-ups</p>
      </div>
      <div className="rounded-lg border border-white/10 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-white/5 text-gray-400 text-left">
            <tr><th className="p-3">Email</th><th className="p-3">Name</th><th className="p-3">Details</th><th className="p-3">Joined</th><th className="p-3"></th></tr>
          </thead>
          <tbody>
            {data.entries.map((e) => (
              <tr key={e.id} className="border-t border-white/5" data-testid={`admin-waitlist-row-${e.id}`}>
                <td className="p-3 text-white">{e.email}</td>
                <td className="p-3 text-gray-300">{e.name || '-'}</td>
                <td className="p-3 text-gray-400">{[e.business_name, e.segment, e.phone].filter(Boolean).join(' · ') || '-'}</td>
                <td className="p-3 text-gray-400">{e.created_at ? new Date(e.created_at).toLocaleDateString('en-IN') : '-'}</td>
                <td className="p-3 text-right">
                  <Button size="icon" variant="ghost" onClick={() => remove(e.id)} data-testid={`admin-waitlist-delete-${e.id}`}
                    className="text-gray-400 hover:text-red-400 hover:bg-white/10">
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </td>
              </tr>
            ))}
            {data.entries.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-gray-500">No waitlist entries</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
